import HTTP from '@/utils/http';

const ConnectorValues = {
  getSelectOptions: dataType => HTTP.get(`selects/${dataType}`).then(response => response.data),
};

export default ConnectorValues;
